var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendMessage = function SvgSendMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.5 3-6.65 19-2.35-7.5 9-11.5ZM21.5 3 10 12 2.5 9.65 21.5 3Z",
    fill: "#DBDCDD",
    stroke: "#DBDCDD",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
export default SvgSendMessage;